



















import User from '@/types/User.interface'
import Vue, { PropType } from 'vue'
import UserLogo from '@/components/UserLogo.vue'
export default Vue.extend({
    components: { UserLogo },
    props: {
        label: {
            type: String,
            default: 'Select user'
        },
        users: {
            type: Array as PropType<User[]>,
            required: true
        }
    }
})
